import axios from 'axios'
export default {

  async add (business, img) {
    try {
      business.updated_at = Date.now()
      business.created_at = Date.now()
      business.active = true
      delete business._id

      const response = await axios.post('business/add', business)
      if (response.status === 200) {
        if (img != null) {
          const formData = new FormData()
          formData.append('file', img)
          formData.append('_id', response.data._id)
          formData.append('type', 'business')
          await axios.post('files/add', formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          })
        }
        console.log('Negocio agregado correctamente:', response.data)
        return true
      } else {
        console.log('Hubo un problema al agregar el negocio:', response.data)
        return false
      }
    } catch (error) {
      console.error('Error al agregar el negocio:', error)
      return false
    }
  },

  async edit (business, img) {
    try {
      business.updated_at = Date.now()
      const response = await axios.patch('business/update', business)
      if (response.status === 200) {
        if (img != null) {
          const formData = new FormData()
          formData.append('file', img)
          formData.append('_id', response.data._id)
          formData.append('type', 'business')
          await axios.post('files/add', formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          })
        }
        console.log('Negocio editado correctamente:', response.data)
        return true
      } else {
        console.log('Hubo un problema al editar el negocio:', response.data)
        return false
      }
    } catch (error) {
      console.error('Error al editar el negocio:', error)
      return false
    }
  },

  async changeActive (business) {
    try {
      business.active = !business.active
      business.updated_at = Date.now()
      const response = await axios.patch('business/active', business)
      if (response.status === 200) {
        console.log('Negocio editado correctamente:', response.data)
        return true
      } else {
        console.log('Hubo un problema al editar el negocio:', response.data)
        return false
      }
    } catch (error) {
      console.error('Error al editar el negocio:', error)
      return false
    }
  },

  async delete (business) {
    try {
      business.deleted_at = Date.now()
      const response = await axios.patch('business/delete', business)
      if (response.status === 200) {
        console.log('Negocio editado correctamente:', response.data)
        return true
      } else {
        console.log('Hubo un problema al editar el negocio:', response.data)
        return false
      }
    } catch (error) {
      console.error('Error al editar el negocio:', error)
      return false
    }
  },

  async list (search) {
    try {
      const response = await axios.get('business/list?search=' + search)
      return response.data
    } catch (error) {
      console.error(error)
      return []
    }
  }

}
